const datamanagerstatusoperators = (state = [], action) => {
    switch (action.type) {
      case 'HANDLE_DATA_STATUS_OPERATORS':
        return action.data
      default:
        return state
    }
  }
  
  export default datamanagerstatusoperators